export default "__VITE_ASSET__BtqjpcL9__"